module.exports = __webpack_public_path__ + "static/media/14UNEP16.cfab202a.jpg";